import axios from 'axios'
import { tansParams } from "@/utils/utils.js";
import { closeToast, showFailToast, showLoadingToast, showToast } from 'vant';

/** token 过期/无效的后端错误码 */
const TOKEN_EXPIRED_CODE = 202002
/** 防止多个请求同时触发重新授权 */
let isRedirecting = false

const service = axios.create({
    baseURL: import.meta.env.VITE_APP_LJ_BASE_API,
    timeout: 5000,
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
})

// request 拦截器
service.interceptors.request.use(config => {
    // 注入 token
    const token = localStorage.getItem('token')
    if (token) {
        config.headers['token'] = token
    }

    // GET 请求：使用 tansParams 支持嵌套对象序列化（如 { a: { b: 1 } } → a[b]=1）
    if (config.method === 'get' && config.params && Object.keys(config.params).length) {
        config.url += (config.url.includes('?') ? '&' : '?') + tansParams(config.params)
        config.params = {}
    }

    // 非静默请求显示 loading
    if (!config.silence) {
        showLoadingToast({ message: '加载中...', forbidClick: true, loadingType: 'spinner' })
    }

    return config
}, error => {
    console.error('请求拦截错误', error)
    return Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    closeToast()

    // token 过期：清除登录态，刷新当前页触发重新授权
    if (res.data.errcode === TOKEN_EXPIRED_CODE) {
        if (!isRedirecting) {
            isRedirecting = true
            localStorage.removeItem('wjr_token')
            localStorage.removeItem('userInfo')
            window.location.reload()
        }
        return Promise.reject(res.data)
    }

    // 原始响应（跳过业务错误处理）
    if (res.config.raw) return res

    if (res.data.errcode === 0) {
        return res.data.data
    }

    showToast(res.data.errmsg || '请求失败')
    return Promise.reject(res.data)
}, error => {
    closeToast()

    let message = '网络异常，请稍后重试'
    if (error.message?.includes('timeout')) {
        message = '请求超时，请检查网络'
    } else if (error.response?.status >= 500) {
        message = '服务器繁忙，请稍后重试'
    }

    showFailToast({ message, duration: 1500 })
    return Promise.reject(error)
})

export default service
